/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface ICookieComplianceAcceptEssentialButton {
    acceptEssentialCookiesButtonText?: string;
    acceptEssentialCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
}

export const CookieComplianceAcceptEssentialButton: React.FC<ICookieComplianceAcceptEssentialButton> = ({
    acceptEssentialCookiesButtonText,
    acceptEssentialCookiesButtonAriaLabel,
    telemetryContent,
    onClose
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'accept essential cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <button
            type='button'
            className='ms-cookie-compliance__accept-essential-button msc-btn'
            aria-label={acceptEssentialCookiesButtonAriaLabel}
            onClick={onClose}
            {...attributes}
        >
            {acceptEssentialCookiesButtonText}
        </button>
    );
};
